import { Autocomplete as RHFAutocomplete } from "$components/rhf-fields";
import TextField from "$components/text-field";
import { useIntl } from "react-intl";
import type { PriceListItemRow } from "../types";

interface PriceListItemInputProps {
  name: string;
  priceListItems: PriceListItemRow[];
  disabled: boolean;
}

export const PriceListItemInput = ({
  name,
  priceListItems = [],
  disabled = false,
}: PriceListItemInputProps) => {
  const { formatMessage } = useIntl();

  const itemNotFound = formatMessage({
    id: "invoicing.lineItems.pricelist.itemNotFound",
    defaultMessage: "Item not found",
  });
  return (
    <RHFAutocomplete
      disabled={disabled}
      name={name}
      options={priceListItems}
      noOptionsText={itemNotFound}
      getOptionLabel={(option: PriceListItemRow) => option.name}
      getOptionSelected={(option, value) => option.uuid === value.uuid}
      fullWidth
      disableClearable
      renderInput={(errStr) => (params) => {
        return (
          <TextField
            {...params}
            name={name}
            required
            error={errStr}
            inputProps={{
              ...params.inputProps,
            }}
          />
        );
      }}
    />
  );
};
